import Vue from 'vue'
import { Filter as IFilter } from 'services/api-service'
import Listbox from 'objects/listbox/listbox'
import reviewsStore from 'store/reviews-store'

import withRender from './review-filters.html'
import './review-filters.scss'

export default withRender(Vue.extend({
  data() {
    return {
      reviewsStore
    }
  },
  components: {
    'tt-listbox': Listbox
  },
  computed: {
    filterValues() {
      return this.reviewsStore.filterStore.filterValues
    },
    listBoxValues() {
      const filters = reviewsStore.filterStore.filters
      // want to make sure we have the filterValues set before including
      return filters.filter((filter: IFilter) => {
        return !filter.hidden && !!this.filterValues[filter.group] &&
          Object.keys(this.filterValues[filter.group]).indexOf(filter.name) > -1
      }).map((filter: IFilter) => {
        return {
          filter,
          label: filters.length === 1 ? this.$msg('reviewsList.filter') : '',
          model: this.filterValues[filter.group][filter.name],
          multiSelect: filter.type === 'array',
          subLabel: filter.labelKey ? this.$msg(filter.labelKey) : filter.label
        }
      })
    }
  },
  methods: {
    onChange(filter, value) {
      reviewsStore.filterStore.setFilterValue(filter, value)
    }
  }
}))
